<template>
  <div class="d-f fd-c ai-c w-100 m-b-children">

    <SettingsLabelDropboxDropdown
      :checked="acceptingSubmissions"
      title="Submit Demo Button"
      subtitle=""
      :show-checkbox="true"
      @on-change="toggleAcceptingSubmissions"
    >
      <!-- <p class="mute">Add criteria and assessment for the demo uploads:</p> -->
      <div class="input-container w-100 desc-field desc-textarea-wrap">
        <label class="label" for="settings-dropbox-demo-criteria"
          >Define criteria for demo assessment...</label
        >
        <textarea
          id="settings-dropbox-demo-criteria"
          class="desc-textarea"
          maxlength="800"
          rows="3"
          placeholder="Define criteria for demo assessment..."
          v-model="demoCriteria"
        />
      </div>
    </SettingsLabelDropboxDropdown>

    <div class="label-divider p-rel w-100">
      <span class="w-100 b-bottom p-a pos-center"></span>
      <h4 class="font-small mute tt-up p-a pos-center m-0 t-100 bc-brand p">
        External Script Widget
      </h4>
    </div>

    <SettingsLabelWidgetSnippet
      :widget-code="widgetCode"
      @copy="copyWidgetCode"
    />
    <div class="save-buttons d-f jc-c ai-c p-f b-0 bc-brand w-100 m-b-0 p">
      <div class="d-f g">
        <button type="button" class="secondary d-f ai-c" @click="goBack">
          Cancel
        </button>
        <button
          :disabled="!dataChanged || saving"
          class="primary d-f ai-c g"
          type="button"
          @click="handleSaveAndClose"
        >
          <span>{{ saving ? "Saving changes" : "Save changes" }}</span>
          <!-- <IconBase color="#fff" w="15" h="15" view-box="0 0 15 15" icon-name="back">
            <IconCheck />
          </IconBase> -->
        </button>
        <!-- <button
          :disabled="saving"
          class="d-f ai-c g"
          type="submit"
          @click.prevent="handleNext"
        >
          Next
          <IconBase color="#000" h="16" icon-name="continue" w="16">
            <IconArrowRight />
          </IconBase>
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import IconCheck from "@/assets/icons/IconCheck.vue";
import IconArrowRight from "@/assets/icons/IconArrowRight.vue";
import IconBase from "@/assets/icons/IconBase.vue";
import SettingsLabelDropboxDropdown from "@/components/settings/SettingsLabelDropboxDropdown.vue";
import SettingsLabelWidgetSnippet from "@/components/settings/SettingsLabelWidgetSnippet.vue";

const demoWidgetTemplate = `<div id="algorhythm-div">
  <div class="algorhythm-div-c"><span class="algorhythm-div-upload"><svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1.5L11.25 4.5M8 1.5L5 4.5M8 1.5V11M14 7V13.5H2V7" stroke="white"/></svg><h4>UPLOAD DEMO HERE</h4><a href="https://algorhythm.world/submit_demo?label=__LABEL_UNAME__" target="_blank"></a></span><div class="criteria"><label for="criteria-cb" class="criteria-title">CRITERIA & ASSESSMENT</label><input type="checkbox" id="criteria-cb"><div class="criteria-text">__CRITERIA__</div></div></div>
  <style>
    #algorhythm-div{all:unset}#algorhythm-div .algorhythm-div-c{color:white;width:300px;background-color:black;padding:10px;font-family:"Satoshi-Medium",Helvetica,Arial,sans-serif;font-weight:400;position:fixed;bottom:10px;right:10px;display:flex;flex-direction:column;gap:10px}#algorhythm-div .algorhythm-div-upload{border:1px dotted #ffffff99;display:flex;align-items:center;justify-content:center;gap:8px;padding:10px;position:relative}#algorhythm-div .algorhythm-div-upload a{position:absolute;inset:0}#algorhythm-div .criteria{text-align:center}#algorhythm-div .criteria-title{text-decoration:underline;cursor:pointer}#algorhythm-div #criteria-cb,#algorhythm-div #criteria-cb+.criteria-text{display:none}#algorhythm-div #criteria-cb:checked+.criteria-text{display:block;max-height:400px;text-align:start;overflow:scroll;white-space:pre-wrap}
  </style>
</div>`;

export default {
  name: "SettingsLabelDropbox",
  components: {
    SettingsLabelDropboxDropdown,
    SettingsLabelWidgetSnippet,
    IconBase,
    IconArrowRight,
    IconCheck,
  },
  props: {
    /**
     * @type {labelSettings}
     */
    labelSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      acceptingSubmissions: this.labelSettings.acceptingSubmissions ?? false,
      demoCriteria: this.labelSettings.demoCriteria,
      widgetCode: demoWidgetTemplate
        .replace("__LABEL_UNAME__", this.labelSettings.username)
        .replace("__CRITERIA__", this.labelSettings.demoCriteria || "None"),
    };
  },
  methods: {
    toggleAcceptingSubmissions(v) {
      this.acceptingSubmissions = v;
    },
    copyWidgetCode() {
      navigator.clipboard.writeText(this.widgetCode);
    },
    handleSaveAndClose() {
      this.saveData((success) => {
        if (success) {
          console.log("Saved successfully");
          this.$store.dispatch('togglePopMess', "Changes saved!");
        }
      });
    },
    handleNext() {
      if (!this.dataChanged) {
        this.$emit("nextTab");
      } else {
        this.saveData((success) => {
          if (success) {
            this.$emit("nextTab");
          }
        });
      }
    },
    async saveData(onComplete) {
      if (!this.dataChanged) {
        onComplete(true);
        return;
      }

      this.saving = true;

      this.$emit("saveSettings", this.newDataObj, (success) => {
        this.saving = false;
        onComplete?.(success);
      });
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1); // Go back one step
      } else {
        this.$router.push("/"); // Navigate to the home page
      }
    },
  },
  computed: {
    newDataObj() {
      const obj = {
        acceptingSubmissions: this.acceptingSubmissions ?? false,
        demoCriteria: this.demoCriteria,
      };

      if (
        this.labelSettings.acceptingSubmissions === obj.acceptingSubmissions
      ) {
        delete obj.acceptingSubmissions;
      }

      if (this.labelSettings.demoCriteria === obj.demoCriteria) {
        delete obj.demoCriteria;
      }

      return obj;
    },
    dataChanged() {
      return Object.keys(this.newDataObj).length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";
</style>
